// prettier-ignore
export const MyCompany = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path fill="currentColor" fillRule="evenodd" d="M5.83 2.5c0-.46.38-.83.84-.83h6.66c.46 0 .84.37.84.83V5h3.33c.46 0 .83.37.83.83V17.5c0 .46-.37.83-.83.83h-15a.83.83 0 0 1-.83-.83V5.83c0-.46.37-.83.83-.83h3.33V2.5Zm0 4.17h-2.5v10h2.5v-10Zm1.67 10h5v-10h-5v10ZM12.5 5h-5V3.33h5V5Zm1.67 1.67v10h2.5v-10h-2.5Z" clipRule="evenodd"/>
  </svg>
)
